import { checkInn } from '../../api';
import createAsyncValidator from '../../core/createAsyncValidator';
import memoization from '../../utils/memoization';

const innValidation = (cacheProps = {}) =>
  createAsyncValidator(memoization(checkInn, cacheProps));

export default innValidation;
